// extracted by mini-css-extract-plugin
export default {"breakdowntitle":"mm","result_page":"nm","what_are_calories":"om","title":"pm","copy":"qm","chart":"rm","to_reach":"sm","title_wrapper":"tm","rhode_percent":"um","what_are_macro":"vm","text":"wm","img":"xm","macros_wrapper":"ym","macros":"zm","macro_item":"Am","value":"Bm","note":"Cm","btn":"Em","carbo_item":"Fm","faq":"Gm","faq_items":"Hm"};
    if(module.hot) {
      // 1738064236101
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  